import React from "react";

const ValueFinder = ({ data, title }) => {
  const item = data.find((entry) => entry.value === title);
  const label = item ? item.label : "*";
  const className = item ? item.class : "*";

  return <div className={className}>{label}</div>;
};

export default ValueFinder;
